import React from 'react';
import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { resolveImage } from '../utils/imageHelper';
import { getBonusIcon, getWithdrawIcon } from '../utils/icons';

const AppRow = ({ app, BonusIcon, WithdrawIcon }) => (
  <div className="flex items-center justify-between gap-3 px-3 sm:px-5 py-3 sm:py-4 border-b border-gray-200 hover:bg-gray-50 transition-colors">
    <Link to={`/app/${app.slug}`} className="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
      <img
        src={resolveImage(app.image)}
        alt={app.name}
        className="w-14 h-14 sm:w-16 sm:h-16 rounded-lg object-cover shadow flex-shrink-0"
        loading="lazy"
      />
      <div className="flex flex-col min-w-0">
        <span className="text-sm sm:text-base font-semibold text-gray-900 truncate hover:text-[#6a1b7d] transition-colors">
          {app.name}
        </span>
        <div className="mt-1 flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-4">
          <span className="inline-flex items-center gap-1 text-xs sm:text-sm text-[#c62828] font-medium">
            <BonusIcon className="w-3.5 h-3.5" />
            Welcome Bonus ₹{app.bonus}
          </span>
          <span className="inline-flex items-center gap-1 text-xs sm:text-sm text-[#0f8a4a] font-medium">
            <WithdrawIcon className="w-3.5 h-3.5" />
            Min Withdraw ₹{app.minWithdraw}
          </span>
        </div>
      </div>
    </Link>
    <Link
      to={`/app/${app.slug}`}
      className="inline-flex items-center gap-1.5 bg-[#0f8a4a] hover:bg-[#0b6f3b] text-white text-xs sm:text-sm font-medium px-3 sm:px-4 py-2 rounded-md shadow transition-colors flex-shrink-0"
    >
      <Download className="w-3.5 h-3.5" />
      Download
    </Link>
  </div>
);

const AppList = () => {
  const { mainApps, settings } = useSite();
  const BonusIcon = getBonusIcon(settings?.bonusIcon);
  const WithdrawIcon = getWithdrawIcon(settings?.withdrawIcon);
  if (!mainApps || mainApps.length === 0) return null;
  return (
    <section className="w-full bg-white">
      <div className="max-w-6xl mx-auto">
        {mainApps.map((app) => <AppRow key={app.id} app={app} BonusIcon={BonusIcon} WithdrawIcon={WithdrawIcon} />)}
      </div>
    </section>
  );
};

export default AppList;
